var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "header-controls project-header-controls",
      attrs: { id: "header__controls" }
    },
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "feedbackModal",
            title: "Send Feedback"
          }
        },
        [_c("FeedbackModal", { ref: "refFeedbackModal" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-7 col-md-8 col-8 left-side" }, [
            _vm.$router.currentRoute.name != "permissionManager" &&
            _vm.$router.currentRoute.name != "globalAlert" &&
            _vm.$router.currentRoute.name != "userGlobalAlert"
              ? _c(
                  "div",
                  {
                    staticClass: "form-inline",
                    class:
                      _vm.$router.currentRoute.name != "project" &&
                      _vm.$router.currentRoute.name != "myProjects"
                        ? "d-none"
                        : ""
                  },
                  [
                    _c("div", { staticClass: "input-group top-search" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchQuery,
                            expression: "searchQuery"
                          },
                          {
                            name: "debounce",
                            rawName: "v-debounce:500ms",
                            value: _vm.setQuery,
                            expression: "setQuery",
                            arg: "500ms"
                          }
                        ],
                        ref: "searchQuery",
                        staticClass: "form-control",
                        class:
                          _vm.$router.currentRoute.name == "globalSearch"
                            ? ""
                            : "media-calls-search",
                        attrs: {
                          type: "text",
                          "debounce-events": ["keyup"],
                          placeholder:
                            _vm.$router.currentRoute.name == "globalSearch"
                              ? "Global search..."
                              : "Search projects...",
                          id: "search-query"
                        },
                        domProps: { value: _vm.searchQuery },
                        on: {
                          click: function($event) {
                            return _vm.$refs.searchQuery.select()
                          },
                          keypress: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.triggerSearch.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchQuery = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "input-group-append cursor-pointer",
                          on: { click: _vm.triggerSearch }
                        },
                        [_vm._m(0)]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name != "globalSearch"
                      ? _c(
                          "b-button",
                          {
                            ref: "filterBoxBtn",
                            staticClass: "ml-2 header-filter-btns",
                            attrs: {
                              id: "popover-button-event",
                              variant: "theme",
                              tabindex: "0",
                              href: "#"
                            },
                            on: {
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "esc",
                                    27,
                                    $event.key,
                                    ["Esc", "Escape"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.$refs.popover.$emit("close")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "wider-filter-only" }, [
                              _vm._v("Filter")
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("@/csmworkflow/img/filter.svg")
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-popover",
                      {
                        ref: "popover",
                        attrs: {
                          triggers: "click blur",
                          boundary: "window",
                          placement: "bottom",
                          target: "popover-button-event",
                          "custom-class": "deliverable-filter"
                        }
                      },
                      [
                        _c("div", { staticClass: "d-flex flex-row" }, [
                          _c("div", { staticClass: "grouped-filter-item" }, [
                            _c(
                              "div",
                              { staticClass: "filter-item item__status" },
                              [
                                _c("label", [_vm._v("Project Status")]),
                                _vm._v(" "),
                                !_vm.isMobile()
                                  ? _c(
                                      "div",
                                      { staticClass: "status-wrap" },
                                      _vm._l(_vm.statuses, function(s, index) {
                                        return _c(
                                          "a",
                                          {
                                            key: index,
                                            staticClass: "badge mr-2",
                                            style: {
                                              color: "var(--wf-secondary)",
                                              backgroundColor: s.color
                                            },
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                return _vm.setStatusFilter(s)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(s.name))]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "custom-field status-field" },
                                  [
                                    _vm.isMobile()
                                      ? _c("multiselect", {
                                          attrs: {
                                            searchable: true,
                                            label: "name",
                                            options: _vm.statuses,
                                            placeholder: "Select status",
                                            "show-labels": false,
                                            multiple: true,
                                            "hide-selected": true
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "option",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        style: {
                                                          color:
                                                            "var(--wf-secondary)",
                                                          borderRadius: "10px",
                                                          backgroundColor:
                                                            props.option.color,
                                                          height: "40px",
                                                          lineHeight: "40px",
                                                          textAlign: "center"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.option.name
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              },
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        style: {
                                                          color:
                                                            "var(--wf-secondary)",
                                                          borderRadius: "10px",
                                                          backgroundColor:
                                                            props.option.color,
                                                          textAlign: "center",
                                                          display:
                                                            "inline-block",
                                                          padding: "5px 10px",
                                                          marginRight: "5px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.option.name
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1936226673
                                          ),
                                          model: {
                                            value: _vm.filterQuery.status,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filterQuery,
                                                "status",
                                                $$v
                                              )
                                            },
                                            expression: "filterQuery.status"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "grouped-filter-item" }, [
                            _c(
                              "div",
                              { staticClass: "filter-item item__coordinator" },
                              [
                                _c("label", [_vm._v("Assigned To")]),
                                _vm._v(" "),
                                _vm.$router.currentRoute.name == "project" &&
                                _vm.isMobile()
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "float-right csm-checkbox",
                                        attrs: {
                                          id: "no-coordinator",
                                          name: "no-coordinator",
                                          value: "accepted",
                                          "unchecked-value": "not_accepted"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.filterQuery.noCoordinator ==
                                            "accepted"
                                              ? (_vm.filterQuery.coordinator = [])
                                              : ""
                                          }
                                        },
                                        model: {
                                          value: _vm.filterQuery.noCoordinator,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "noCoordinator",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "filterQuery.noCoordinator"
                                        }
                                      },
                                      [_vm._v("Not Assigned To Anyone")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "coordinator-wrap" },
                                  [
                                    _c("multiselect", {
                                      ref: "coordinatorFilter",
                                      attrs: {
                                        options: _vm.allActiveUsers,
                                        "show-labels": false,
                                        multiple: true,
                                        "open-direction": "bottom",
                                        label: "name",
                                        "track-by": "id",
                                        "hide-selected": true,
                                        "close-on-select": false,
                                        "clear-on-select": false
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function(ref) {
                                              var values = ref.values
                                              var search = ref.search
                                              var isOpen = ref.isOpen
                                              return [
                                                values.length && !isOpen
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__single"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            values.length
                                                          ) +
                                                            " options selected"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        249740006
                                      ),
                                      model: {
                                        value: _vm.filterQuery.coordinator,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filterQuery,
                                            "coordinator",
                                            $$v
                                          )
                                        },
                                        expression: "filterQuery.coordinator"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.$router.currentRoute.name == "project" &&
                                !_vm.isMobile()
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "mt-2 csm-checkbox",
                                        attrs: {
                                          id: "no-coordinator",
                                          name: "no-coordinator",
                                          value: "accepted",
                                          "unchecked-value": "not_accepted"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.filterQuery.noCoordinator ==
                                            "accepted"
                                              ? (_vm.filterQuery.coordinator = [])
                                              : ""
                                          }
                                        },
                                        model: {
                                          value: _vm.filterQuery.noCoordinator,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "noCoordinator",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "filterQuery.noCoordinator"
                                        }
                                      },
                                      [_vm._v("Not Assigned To Anyone")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "filter-item item__department" },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("label", [_vm._v("Department")]),
                                    _vm._v(" "),
                                    _vm.isMobile()
                                      ? _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass:
                                              "float-right csm-checkbox",
                                            attrs: {
                                              id: "no-department",
                                              name: "no-department",
                                              value: "accepted",
                                              "unchecked-value": "not_accepted"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.filterQuery.noDepartment ==
                                                "accepted"
                                                  ? (_vm.filterQuery.department = [])
                                                  : ""
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.filterQuery.noDepartment,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "noDepartment",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterQuery.noDepartment"
                                            }
                                          },
                                          [_vm._v("No Department")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "tag-wrap" },
                                  [
                                    _c(
                                      "multiselect",
                                      {
                                        ref: "departmentFilter",
                                        attrs: {
                                          "open-direction": "bottom",
                                          label: "name",
                                          "track-by": "id",
                                          options: _vm.departments,
                                          "hide-selected": true,
                                          "show-labels": false,
                                          multiple: true,
                                          "close-on-select": false,
                                          "clear-on-select": false
                                        },
                                        on: {
                                          select: function($event) {
                                            _vm.filterQuery.noDepartment =
                                              "not_accepted"
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function(ref) {
                                                var values = ref.values
                                                var search = ref.search
                                                var isOpen = ref.isOpen
                                                return [
                                                  values.length && !isOpen
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "multiselect__single"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              values.length
                                                            ) +
                                                              " options selected"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          249740006
                                        ),
                                        model: {
                                          value: _vm.filterQuery.department,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "department",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.department"
                                        }
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("template", { slot: "noOptions" }, [
                                          _vm._v(
                                            "Start typing to find departments."
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("template", { slot: "noResult" }, [
                                          _vm._v(
                                            "No results. Please try changing the search query."
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.isMobile()
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "mt-2 csm-checkbox",
                                        attrs: {
                                          id: "no-department",
                                          name: "no-department",
                                          value: "accepted",
                                          "unchecked-value": "not_accepted"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.filterQuery.noDepartment ==
                                            "accepted"
                                              ? (_vm.filterQuery.department = [])
                                              : ""
                                          }
                                        },
                                        model: {
                                          value: _vm.filterQuery.noDepartment,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "noDepartment",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.noDepartment"
                                        }
                                      },
                                      [_vm._v("No Department")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "filter-item filter-item-no-border item__date"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "due__created__dates" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("label", [_vm._v("Due Date")]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("date-range-picker", {
                                        ref: "picker",
                                        attrs: {
                                          autoApply: true,
                                          ranges: _vm.customDueDateRanges
                                        },
                                        on: { update: _vm.onUpdateDueDate },
                                        model: {
                                          value: _vm.filterQuery.dateRange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "dateRange",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.dateRange"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("label", { staticClass: "mt-2" }, [
                                        _vm._v("Created")
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("date-range-picker", {
                                        ref: "pickerDateCreated",
                                        attrs: {
                                          autoApply: true,
                                          ranges: _vm.customCreatedDateRanges
                                        },
                                        on: { update: _vm.onUpdateDateCreated },
                                        model: {
                                          value:
                                            _vm.filterQuery.dateCreatedRange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "dateCreatedRange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "filterQuery.dateCreatedRange"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "item__reset" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant: "theme",
                                      title: "Reset All Filter",
                                      size: "sm"
                                    },
                                    on: { click: _vm.resetFilter }
                                  },
                                  [_c("i", { staticClass: "fas fa-undo" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "d-block d-lg-none",
                                    attrs: {
                                      variant: "theme",
                                      title: "Close Filter Popup",
                                      size: "sm"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.popover.$emit("close")
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fas fa-times" })]
                                )
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.isFilterActive()
                          ? _c(
                              "div",
                              { staticClass: "d-none d-md-block mt-3 test1" },
                              [
                                _c("label", [
                                  _vm._v("Click to remove filters:")
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.query = null
                                        _vm.searchQuery = ""
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.filterQuery.query))]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.status, function(
                                  status
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass: "badge mr-2 mb-2",
                                      style: {
                                        cursor: "pointer",
                                        color: "var(--wf-secondary)",
                                        backgroundColor: status.color
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(status)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(status.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.outlet, function(
                                  outlet
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(outlet)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(outlet.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.filterQuery.deliverableType,
                                  function(deliverableType) {
                                    return _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              deliverableType
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(deliverableType.name))]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm.filterQuery.priorityFilter > 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              "resetPriorityFilter"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Priority " +
                                            _vm._s(
                                              _vm.filterQuery.priorityFilter
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$router.currentRoute.name !=
                                  "globalSearch" && _vm.filterQuery.sort
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge mr-2 mb-2 bg-primary cursor-pointer",
                                        staticStyle: {
                                          color: "var(--wf-secondary)"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter("sort")
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Sorting Active\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.coordinator, function(
                                  coordinator
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(coordinator)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(coordinator.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.filterQuery.filterByDate
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              "filterByDate"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Due Date: " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.filterQuery.dateRange
                                                  .startDate,
                                                "MMM DD"
                                              )
                                            ) +
                                            " - " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.filterQuery.dateRange
                                                  .endDate,
                                                "MMM DD"
                                              )
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.filterQuery.filterNoDueDate == 1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            _vm.filterQuery.filterNoDueDate = false
                                          }
                                        }
                                      },
                                      [_vm._v("No Due Date")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.filterQuery.filterByDateCreated
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              "filterByDateCreated"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Created: " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.filterQuery.dateCreatedRange
                                                  .startDate,
                                                "MMM DD"
                                              )
                                            ) +
                                            " - " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.filterQuery.dateCreatedRange
                                                  .endDate,
                                                "MMM DD"
                                              )
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.filterQuery.filterByDateCompleted
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              "filterByDateCompleted"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Completed: " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.filterQuery
                                                  .dateCompletedRange.startDate,
                                                "MMM DD"
                                              )
                                            ) +
                                            " - " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.filterQuery
                                                  .dateCompletedRange.endDate,
                                                "MMM DD"
                                              )
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.tag, function(tag) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(tag)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(tag.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.department, function(
                                  department
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(department)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(department.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.filterQuery.noDepartment == "accepted"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            _vm.filterQuery.noDepartment =
                                              "not_accepted"
                                          }
                                        }
                                      },
                                      [_vm._v("No Department")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.filterQuery.noCoordinator == "accepted"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            _vm.filterQuery.noCoordinator =
                                              "not_accepted"
                                          }
                                        }
                                      },
                                      [_vm._v("No Coordinator")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.filterQuery.noOutlet == "accepted"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            _vm.filterQuery.noOutlet =
                                              "not_accepted"
                                          }
                                        }
                                      },
                                      [_vm._v("No Outlet")]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm.userCanCreateProject
                      ? _c(
                          "b-button",
                          {
                            staticClass: "ml-2 header-filter-btns",
                            attrs: { variant: "theme" },
                            on: {
                              click: function($event) {
                                return _vm.createNewProject()
                              }
                            }
                          },
                          [
                            _vm._v("\n            Project\n            "),
                            _c("i", {
                              staticClass:
                                "fas text-primary float-right fa-plus fa-fw"
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-2 wider-filter-only" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "filter-project-department-wrap report-type audit-log-user",
                          staticStyle: { "max-width": "200px" }
                        },
                        [
                          _c(
                            "multiselect",
                            {
                              ref: "departmentFilter",
                              attrs: {
                                "open-direction": "bottom",
                                label: "name",
                                "track-by": "id",
                                options: _vm.departments,
                                "hide-selected": true,
                                "show-labels": false,
                                multiple: true,
                                "close-on-select": false,
                                "clear-on-select": false,
                                placeholder: "Filter by department"
                              },
                              on: {
                                select: function($event) {
                                  _vm.filterQuery.noDepartment = "not_accepted"
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var values = ref.values
                                      var search = ref.search
                                      var isOpen = ref.isOpen
                                      return [
                                        values.length && !isOpen
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "multiselect__single"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(values.length) +
                                                    " options selected"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                249740006
                              ),
                              model: {
                                value: _vm.filterQuery.department,
                                callback: function($$v) {
                                  _vm.$set(_vm.filterQuery, "department", $$v)
                                },
                                expression: "filterQuery.department"
                              }
                            },
                            [
                              _vm._v(" "),
                              _c("template", { slot: "noOptions" }, [
                                _vm._v("Start typing to find departments.")
                              ]),
                              _vm._v(" "),
                              _c("template", { slot: "noResult" }, [
                                _vm._v(
                                  "No results. Please try changing the search query."
                                )
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name != "projectDeliverable"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "ml-2 project-sort mobile-sort cursor-pointer mobile-filter-only"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass:
                                  "header-sort-btns auto-width-button",
                                attrs: {
                                  variant: "theme",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }
                              },
                              [
                                _vm.currentSort
                                  ? _c("span", { staticClass: "icon" }, [
                                      _c("i", {
                                        class:
                                          "fas text-primary " +
                                          _vm.currentSort.icon
                                      })
                                    ])
                                  : _c("span", { staticClass: "icon" }, [
                                      _c("i", {
                                        class:
                                          "fas text-primary fa-sort-amount-down"
                                      })
                                    ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-menu sortmenu-dropdown"
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "perfect-scrollbar",
                                      {
                                        ref: "sort__scroll",
                                        staticClass: "sort__scroll"
                                      },
                                      [
                                        _c(
                                          "div",
                                          _vm._l(_vm.sortOptions, function(
                                            sortOption,
                                            index
                                          ) {
                                            return _c(
                                              "a",
                                              {
                                                key:
                                                  "projectSort" +
                                                  index +
                                                  1 * Math.random(),
                                                staticClass: "dropdown-item",
                                                class: {
                                                  active:
                                                    _vm.currentSort.id ==
                                                    sortOption.id
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setSort(
                                                      sortOption
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "preset-icon-wrap"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "sort-title" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(sortOption.title)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name != "projectDeliverable"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "ml-2 mobile-views-section cursor-pointer mobile-filter-only"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.headerViewSelectModal",
                                    modifiers: { headerViewSelectModal: true }
                                  }
                                ],
                                ref: "MobileViewButton",
                                staticClass:
                                  "header-view-btns auto-width-button",
                                attrs: {
                                  variant: "theme",
                                  id: "MobileViewButton"
                                }
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("i", {
                                    staticClass: "fas fa-fw fa-eye text-primary"
                                  })
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch"
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "b-button",
                              {
                                ref: "GSCreatedDate",
                                staticClass: "ml-md-2 header-filter-btns",
                                attrs: {
                                  variant: "theme",
                                  id: "GSCreatedDate"
                                },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.$refs.GSCreatedDatePopover.$emit(
                                      "close"
                                    )
                                  },
                                  click: function($event) {
                                    _vm.GSCreatedDatePopover = !_vm.GSCreatedDatePopover
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Created Date\n              "
                                ),
                                _c("i", {
                                  staticClass:
                                    "far fa-calendar-check text-primary"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                ref: "GSCreatedDatePopover",
                                attrs: {
                                  show: _vm.GSCreatedDatePopover,
                                  target: "GSCreatedDate",
                                  triggers: "click blur",
                                  placement: "bottom",
                                  "custom-class":
                                    "filter_popover__gs created-date-popover"
                                },
                                on: {
                                  "update:show": function($event) {
                                    _vm.GSCreatedDatePopover = $event
                                  }
                                }
                              },
                              [
                                _c("date-range-picker", {
                                  ref: "pickerDateCreated",
                                  attrs: {
                                    opens: "inline",
                                    autoApply: true,
                                    ranges: _vm.customCreatedDateRanges
                                  },
                                  on: { update: _vm.onUpdateDateCreated },
                                  model: {
                                    value: _vm.filterQuery.dateCreatedRange,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filterQuery,
                                        "dateCreatedRange",
                                        $$v
                                      )
                                    },
                                    expression: "filterQuery.dateCreatedRange"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    (_vm.GSDataType == "departments" ||
                      _vm.GSDataType == "tags" ||
                      _vm.GSDataType == "contacts" ||
                      _vm.GSDataType == "coordinators")
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ml-md-2 toggle-dept-status cursor-pointer",
                                on: {
                                  click: function($event) {
                                    _vm.filterQuery.status[0] == "Active"
                                      ? (_vm.filterQuery.status = ["Archived"])
                                      : (_vm.filterQuery.status = ["Active"])
                                  }
                                }
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "header-filter-btns",
                                    class: {
                                      "none-active-btn":
                                        _vm.filterQuery.status[0] != "Active"
                                    },
                                    attrs: { variant: "theme" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Active\n                "
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "fas fa-toggle-on text-primary float-right ml-2"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "header-filter-btns",
                                    class: {
                                      "none-active-btn":
                                        _vm.filterQuery.status[0] != "Archived"
                                    },
                                    attrs: { variant: "theme" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Archived\n                "
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "fas fa-toggle-off text-primary float-right ml-2"
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    (_vm.GSDataType == "departments" ||
                      _vm.GSDataType == "tags")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "btn-group add-new__global_search sorting"
                          },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSort("usedDesc")
                                    }
                                  }
                                },
                                [_vm._v("Frequency Decending")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSort("usedAsc")
                                    }
                                  }
                                },
                                [_vm._v("Frequency Ascending")]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    _vm.GSDataType == "all"
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass:
                                  "ml-md-2 header-filter-btns dropdown-toggle",
                                attrs: {
                                  variant: "theme",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }
                              },
                              [_vm._v("Add")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _vm.userAbilities.createTag ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("click", "tag")
                                        }
                                      }
                                    },
                                    [_vm._v("Add Tags")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createContact ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("click", "contact")
                                        }
                                      }
                                    },
                                    [_vm._v("Add Contacts")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createUser
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "click",
                                            "coordinator"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Add Coordinators")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createDepartment ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "click",
                                            "department"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Add Departments")]
                                  )
                                : _vm._e()
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    _vm.GSDataType != "all"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "btn-group add-new__global_search specific-btn",
                            class: !_vm.checkPermissions ? "no-permission" : ""
                          },
                          [
                            _vm.checkPermissions
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "ml-md-2 header-filter-btns action",
                                    attrs: { variant: "theme" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.$emit(
                                          "click",
                                          _vm.GSDataType.substring(
                                            0,
                                            _vm.GSDataType.length - 1
                                          )
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Add\n              "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "text-transform": "capitalize"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.tabType))]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "btn-group" },
                              [
                                _vm.checkPermissions
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-theme dropdown-toggle options",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Toggle Dropdown")
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.checkPermissions
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "ml-md-2 header-filter-btns dropdown-toggle",
                                        attrs: {
                                          variant: "theme",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [_vm._v("Add")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-menu" }, [
                                  _vm.GSDataType != "tags" &&
                                  (_vm.userAbilities.createTag ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit("click", "tag")
                                            }
                                          }
                                        },
                                        [_vm._v("Add Tags")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "contacts" &&
                                  (_vm.userAbilities.createContact ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "click",
                                                "contact"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add Contacts")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "coordinators" &&
                                  _vm.userAbilities.createUser
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "click",
                                                "coordinator"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add Coordinators")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "departments" &&
                                  (_vm.userAbilities.createDepartment ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "click",
                                                "department"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add Departments")]
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-2" }, [_c("FeedbackBtn")], 1)
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                class:
                  _vm.$router.currentRoute.name != "projectDeliverable"
                    ? "d-none"
                    : ""
              },
              [
                _vm.userCanCreateProject
                  ? _c(
                      "b-button",
                      {
                        staticClass: "ml-2 header-filter-btns",
                        attrs: { variant: "theme" },
                        on: {
                          click: function($event) {
                            return _vm.createNewProject()
                          }
                        }
                      },
                      [
                        _vm._v("\n            Project\n            "),
                        _c("i", {
                          staticClass:
                            "fas text-primary float-right fa-plus fa-fw"
                        })
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.isFilterActive()
              ? _c(
                  "div",
                  { staticClass: "mt-3 filter-badges" },
                  [
                    _c("label", { staticClass: "remove-filter-text" }, [
                      _vm._v("Click to remove filters:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-primary mr-2 mb-2",
                        style: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            _vm.filterQuery.query = null
                            _vm.searchQuery = ""
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.filterQuery.query))]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.status, function(status) {
                      return _vm.$router.currentRoute.name != "globalSearch"
                        ? _c(
                            "span",
                            {
                              staticClass: "badge mr-2 mb-2",
                              style: {
                                cursor: "pointer",
                                color: "var(--wf-secondary)",
                                backgroundColor: status.color
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeFilter(status)
                                }
                              }
                            },
                            [_vm._v(_vm._s(status.name))]
                          )
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch"
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge mr-2 mb-2 bg-primary cursor-pointer",
                            staticStyle: { color: "var(--wf-secondary)" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetDepartStatus")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.filterQuery.status[0]))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    _vm.filterQuery.sort
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge mr-2 mb-2 bg-primary cursor-pointer",
                            staticStyle: { color: "var(--wf-secondary)" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetDepartTagSort")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.filterQuery.sort == "usedDesc"
                                  ? "Frequency Descending"
                                  : "Frequency Ascending"
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.priorityFilter > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetPriorityFilter")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Priority " +
                                _vm._s(_vm.filterQuery.priorityFilter)
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name != "globalSearch" &&
                    _vm.filterQuery.sort
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge mr-2 mb-2 bg-primary cursor-pointer",
                            staticStyle: { color: "var(--wf-secondary)" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("sort")
                              }
                            }
                          },
                          [_vm._v("\n            Sorting Active\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.outlet, function(outlet) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(outlet)
                            }
                          }
                        },
                        [_vm._v(_vm._s(outlet.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.deliverableType, function(
                      deliverableType
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(deliverableType)
                            }
                          }
                        },
                        [_vm._v(_vm._s(deliverableType.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.coordinator, function(coordinator) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(coordinator)
                            }
                          }
                        },
                        [_vm._v(_vm._s(coordinator.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDate
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDate")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Due Date: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterNoDueDate == 1
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.filterNoDueDate = false
                              }
                            }
                          },
                          [_vm._v("No Due Date")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDateCreated
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDateCreated")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Created: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDateCompleted
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDateCompleted")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Completed: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCompletedRange
                                      .startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCompletedRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.tag, function(tag) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(tag)
                            }
                          }
                        },
                        [_vm._v(_vm._s(tag.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.department, function(department) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(department)
                            }
                          }
                        },
                        [_vm._v(_vm._s(department.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.noDepartment == "accepted"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.noDepartment = "not_accepted"
                              }
                            }
                          },
                          [_vm._v("No Department")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.noCoordinator == "accepted"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.noCoordinator = "not_accepted"
                              }
                            }
                          },
                          [_vm._v("No Coordinator")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.noOutlet == "accepted"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.noOutlet = "not_accepted"
                              }
                            }
                          },
                          [_vm._v("No Outlet")]
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-5 col-md-4 col-4 text-right right-side" },
            [
              _c(
                "div",
                { staticClass: "logo-user" },
                [
                  _c("HeaderNotification"),
                  _vm._v(" "),
                  _c("LoggedInUser"),
                  _vm._v(" "),
                  _c("Logo")
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fas fa-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-theme ml-md-2 header-filter-btns dropdown-toggle",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _vm._v("\n              Sort\n              "),
        _c("i", { staticClass: "fas fa-sort text-primary float-right" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }